export default {
  pageTitle: '認証',
  metaDescription: 'TEFはASME U・Rスタンプ、National Board、ISO 9001:2015、MIGAS、EBTKE認証を取得しており、国際基準に準拠した製作を実現しています。',
  hero: { title: '認証' },
  certSection: {
    heading: '認証と規格',
    intro: '当社は以下の品質認証を取得しています：',
    otherCodesIntro: 'また、以下のような他の圧力容器規格にも対応可能です：',
    otherCodes: {
      japanese: '日本規格',
    },
  },
};
